// Premium iPhone 15 Pro-style frame component.
// Wraps any child (video / image) and renders it as if displayed
// on a modern Black Titanium iPhone with Dynamic Island.

export default function IPhoneFrame({ children, className = "" }) {
  return (
    <div
      className={`relative mx-auto w-full max-w-[260px] sm:max-w-[280px] md:max-w-[300px] lg:max-w-[320px] ${className}`}
      data-testid="iphone-frame"
    >
      {/* Ambient gold glow behind the device */}
      <div
        aria-hidden="true"
        className="absolute -inset-10 md:-inset-16 bg-mfp-gold/20 blur-3xl rounded-full pointer-events-none -z-10"
      />
      <div
        aria-hidden="true"
        className="absolute -inset-6 bg-mfp-goldDeep/10 blur-2xl rounded-full pointer-events-none -z-10"
      />

      {/* Outer titanium frame with subtle gold rim */}
      <div
        className="relative rounded-[2.6rem] md:rounded-[3rem] p-[3px] shadow-[0_50px_120px_-20px_rgba(200,169,107,0.35),0_30px_60px_-15px_rgba(0,0,0,0.7)]"
        style={{
          background:
            "linear-gradient(135deg,#3a3a3c 0%,#1c1c1e 25%,#0a0a0a 50%,#1c1c1e 75%,#2c2c2e 100%)",
        }}
      >
        {/* Inner highlight ring */}
        <div className="relative rounded-[2.4rem] md:rounded-[2.85rem] p-[10px] bg-gradient-to-br from-zinc-700 via-zinc-900 to-black">
          {/* Screen */}
          <div
            className="relative bg-black rounded-[1.8rem] md:rounded-[2.1rem] overflow-hidden"
            style={{ aspectRatio: "9 / 19.5" }}
            data-testid="iphone-screen"
          >
            {/* Dynamic Island */}
            <div
              className="absolute top-2 md:top-3 left-1/2 -translate-x-1/2 z-20 bg-black rounded-full flex items-center justify-end pr-1.5"
              style={{ width: "34%", height: "20px" }}
              aria-hidden="true"
            >
              <span className="block w-1.5 h-1.5 rounded-full bg-zinc-700" />
            </div>

            {/* Screen content fills entire surface */}
            <div className="absolute inset-0 flex items-center justify-center">
              {children}
            </div>

            {/* Subtle screen reflection */}
            <div
              aria-hidden="true"
              className="absolute inset-0 pointer-events-none"
              style={{
                background:
                  "linear-gradient(135deg,rgba(255,255,255,0.08) 0%,rgba(255,255,255,0) 30%,rgba(255,255,255,0) 70%,rgba(255,255,255,0.04) 100%)",
              }}
            />
          </div>
        </div>
      </div>

      {/* Side buttons (decorative) */}
      <span
        aria-hidden="true"
        className="absolute left-[-3px] top-[22%] w-[3px] h-12 rounded-l-md bg-gradient-to-r from-black to-zinc-800"
      />
      <span
        aria-hidden="true"
        className="absolute left-[-3px] top-[35%] w-[3px] h-20 rounded-l-md bg-gradient-to-r from-black to-zinc-800"
      />
      <span
        aria-hidden="true"
        className="absolute right-[-3px] top-[30%] w-[3px] h-24 rounded-r-md bg-gradient-to-l from-black to-zinc-800"
      />
    </div>
  );
}
